import React, { useEffect } from 'react';
import { useAppDispatch } from '@/store';
import { authStore } from '@/store/auth';

export const Container: React.FC = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(authStore.asyncActions.logout());
  }, [dispatch]);

  return <React.Fragment />;
};
